import React, { useEffect, useState } from "react";
import PropertyOwnerNavbar from "../Header";
import axios from "axios";
import Modal from "react-modal";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";


const API_BASE = "https://api.propertygalleria.in/master/api";

Modal.setAppElement("#root");

const Bookings_Investor = () => {

    const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [properties, setProjectss] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [editingProperty, setEditingProperty] = useState(null);
  const [form, setForm] = useState({});


  /*======================= fetch project ===================*/




  /* ---------- fetch ---------- */
  const fetchProjects = async () => {
    const res = await axios.get(`${API_BASE}/investorLeads`);

    const filter = res.data.filter(
      po => Number(po.investor_id) === Number(user.id)
    );
    console.log('this is inside filter', filter)

    // const filterr = filter.filter(
    //     po => po.status === 'booked'
    //   );
    setProjectss(filter);
  };


  const [projects, setProjects] = useState([]);

  // const fetchProjectss = async () => {
  //   try {
  //     const res = await axios.get(`${API_BASE}/get/projects`);
  //     console.log('this is response',res.data)
  //     console.log('this i properties inside',properties)
  //     const filter = res.data.filter((p) => p.id === properties.property_id)
  //     setProjects(filter);
  //   }
  //   catch (err) {
  //     console.error(err); alert("Failed to load projects");
  //   }
  // };


  //  this is for agent details 


  const fetchProjectss = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get/projects`);

      const propertyIds = properties.map(p => p.property_id);

      const filter = res.data.filter(project =>
        propertyIds.includes(project.id)
      );

      setProjects(filter);
    } catch (err) {
      console.error(err);
      alert("Failed to load projects");
    }
  };


  const [associates, setAssociates] = useState([]);
  const fetchAssociates = async () => {
    try {
      const res = await axios.get(`${API_BASE}/users/agentss`);
      setAssociates(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch associates");
    }
  };




  useEffect(() => {
    fetchAssociates();
    fetchProjects();
  }, []);

  useEffect(() => {
    if (properties.length > 0) {
      fetchProjectss();
    }
  }, [properties]);


  const mergedProjects = projects.map(project => {
    const property = properties.find(
      p => Number(p.property_id) === Number(project.id)
    );

    const agent = associates.find(
      a => Number(a.id) === Number(property?.handling_agent_id)
    );

    return {
      ...project,        // project/product details
      booking: property, // booking / investor lead
      agent              // agent details
    };
  });


  console.log('this is user', user)
  console.log('this is properties', properties)




  /* ---------- group ---------- */
  // const grouped = projects.reduce((acc, item) => {
  //   const cat = item.category || "Others";
  //   if (!acc[cat]) acc[cat] = [];
  //   acc[cat].push(item);
  //   return acc;
  // }, {});

  const grouped = mergedProjects.reduce((acc, item) => {
    const cat = item.category || "Others";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(item);
    return acc;
  }, {});


  const formatPrice = price =>
    Number(price).toLocaleString("en-IN");

  /* ---------- open modal ---------- */
  const openEdit = (property) => {
    setEditingProperty(property);
    setForm({
      title: property.title,
      location: property.location,
      price: property.price,
      area: property.area,
      description: property.description,
      category: property.category
    });
    setModalOpen(true);
  };

  const update = (k, v) => {
    setForm(form => ({ ...form, [k]: v }));
  }
  /* ---------- submit edit ---------- */
  const handleUpdate = async () => {
    try {
      await axios.put(
        `${API_BASE}/update/project/${editingProperty.id}`,
        form
      );

      alert("Updated successfully");
      setModalOpen(false);
      fetchProjects();
    } catch {
      alert("Update failed");
    }
  };

  /* ---------- reusable input ---------- */
  const Input = ({ label, value, onChange }) => (
    <div style={{ marginBottom: 14 }}>
      <label>{label}</label>
      <input
        value={value || ""}
        onChange={onChange}
        style={{
          width: "100%",
          padding: 12,
          borderRadius: 10,
          border: "1px solid #ddd",
          marginTop: 5
        }}
      />
    </div>
  );




  return (
    <>
      <PropertyOwnerNavbar />

      <div style={{
        padding: 20,
        paddingBottom: 120,
        marginTop: "5%",
        maxWidth: 1400,
        marginInline: "auto"
      }}>
        <h2>My Booked Properties</h2>

        {Object.keys(grouped).map(category => (
          <div key={category} style={{ marginTop: 30 }}>
            <h3>{category}</h3>

            <div style={{
              display: "grid",
              gap: 20,
              justifyContent:
                grouped[category].length === 1
                  ? "center"
                  : "stretch",
              gridTemplateColumns:
                grouped[category].length === 1
                  ? "minmax(300px,500px)"
                  : "repeat(auto-fit,minmax(300px,1fr))"
            }}>
              {grouped[category].map(p => (
                <div key={p.id}
                  style={{
                    background: "#fff",
                    borderRadius: 16,
                    overflow: "hidden",
                    boxShadow:
                      "0 6px 20px rgba(0,0,0,0.08)",
                    position: "relative"
                  }}>

                  {/* EDIT BADGE */}
                  {/* {!modalOpen && (
                    <button
                      onClick={() => openEdit(p)}
                      style={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        background: "#8a2d5d",
                        color: "#fff",
                        border: "none",
                        padding: "5px 12px",
                        borderRadius: 20,
                        cursor: "pointer",
                        fontSize: 12,
                        zIndex: 10
                      }}
                    >
                      ✏ Edit
                    </button>
                  )} */}

                  {/* Images */}
                  <div style={{
                    display: "flex",
                    overflowX: "auto"
                  }}>
                    {p.property_images?.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                         onClick={() => navigate(`/properties/${p.id}`)}
                        alt=""
                        style={{
                          width: "100%",
                          minWidth: "100%",
                          height: 220,
                          objectFit: "cover"
                        }}
                      />
                    ))}
                  </div>

                  {/* Info */}
                  <div style={{ padding: 15 }}>
                    <h4>{p.title}</h4>

                    <p style={{
                      color: "#8a2d5d",
                      fontWeight: 600
                    }}>
                      ₹ {formatPrice(p.price)}
                    </p>

                    <p>📍 {p.location}</p>
                    <p>📐 {p.area} sq ft</p>

                    <span style={{
                      background:
                        p.status === "Sold"
                          ? "#d1fae5"
                          : p.status === "Approved"
                            ? "#ecfdf5"
                            : "#fff7ed",
                      color:
                        p.status === "Sold"
                          ? "#059669"
                          : p.status === "Approved"
                            ? "#16a34a"
                            : "#ea580c",
                      padding: "4px 12px",
                      borderRadius: 20,
                      fontSize: 12
                    }}>
                      {p.booking?.status}
                    </span>

                    {p.agent && (
                      <div style={{
                        marginTop: 10,
                        padding: "8px 12px",
                        background: "#f1f5f9",
                        borderRadius: 10,
                        fontSize: 13
                      }}>
                        👤 This project is assigned to{" "}
                        <strong>{p.agent.full_name}</strong>
                        <br />
                        📞 {p.agent.mobile_number}
                      </div>
                    )}

                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ================= MODAL ================= */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={{
          content: {
            maxWidth: 600,
            margin: "auto",
            borderRadius: 16,
            marginTop: '5%',
            padding: "24px",
            inset: "40px",
            position: "relative"
          }
        }}
      >
        {/* Close Button */}
        {/* <button
    onClick={() => setModalOpen(false)}
    style={{
      position: "absolute",
      top: 10,
      right: 12,
      background: "#f3f4f6",
      border: "none",
      borderRadius: "50%",
      width: 32,
      height: 32,
      cursor: "pointer",
      fontSize: 18,
      fontWeight: "bold",
      lineHeight: "32px"
    }}
  >
    ✕
  </button> */}

        <button
          onClick={() => setModalOpen(false)}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "#f3f4f6",
            border: "none",
            borderRadius: "50%",
            width: 34,
            height: 34,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
        >
          <X size={18} />
        </button>

        <h2>Edit Property</h2>

        <Input
          label="Title"
          value={form.title}
          onChange={(e) => update("title", e.target.value)}
        />

        <Input
          label="Location"
          value={form.location}
          onChange={(e) => update("location", e.target.value)}
        />

        <Input
          label="Price"
          value={form.price}
          onChange={(e) => update("price", e.target.value)}
        />

        <Input
          label="Area"
          value={form.area}
          onChange={(e) => update("area", e.target.value)}
        />

        <textarea
          rows={4}
          value={form.description || ""}
          onChange={(e) =>
            update("description", e.target.value)
          }
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 10,
            border: "1px solid #ddd",
            marginTop: 10
          }}
        />

        <button
          onClick={handleUpdate}
          style={{
            marginTop: 20,
            width: "100%",
            padding: 14,
            borderRadius: 12,
            border: "none",
            background: "#8a2d5d",
            color: "#fff",
            cursor: "pointer"
          }}
        >
          Update Property
        </button>
      </Modal>
    </>
  );
};

export default Bookings_Investor;
